import {
  Button,
  createStyles,
  Grid,
  Link,
  makeStyles,
  Theme,
} from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import Header from "../common/Header";
import { APIConstants } from "../utils/api/constants";
import { APIState } from "../utils/api/reducer";
import { useQueryParams } from "../utils/queryParams";
import Heading from "./Heading";
import { setTrends } from "./store/actions";
import { Trend } from "./store/types";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      minHeight: "100vh",
      paddingTop: 24,
      backgroundColor: "#102341",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        paddingBottom: 0,
      },
    },
    cornerBackground: {
      height: "100%",
      width: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 100,
      background: "linear-gradient(#015ACE, #102341)",
      clipPath: "polygon(0 0, 453px 0, 0% 430px)",
    },
    item: {
      margin: "24px 0",
      [theme.breakpoints.down("sm")]: {
        margin: "12px 0 6px 0",
      },
      zIndex: 100,
    },
    buttonWrapper: {
      zIndex: 1000,
      "& .MuiButton-startIcon": {
        position: "absolute",
        top: 0,
        left: 10,
        marginRight: 8,
        marginBottom: 4,
        "& .rank": {
          fontSize: 14,
        },
      },
    },
    button: {
      backgroundColor: "#015ACE50",
      width: 400,
      padding: "24px 16px 16px 16px",
      fontSize: 12,
      fontWeight: 700,
      margin: "12px 0",
      color: theme.palette.common.white,
      borderRadius: 12,
      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
      textAlign: "center",
      "&:hover": {
        backgroundColor: "#015ACE50",
      },
    },
    link: {
      color: "white",
      marginBottom: 8,
      fontFamily: "Roboto",
      fontSize: 20,
      textDecoration: "underline",
    },
  })
);

type PlayerCompareParams = {
  readonly league: string;
};

interface ReduxProps {
  readonly trends: APIState<Trend[]>;
}

interface DispatchProps {
  readonly SetTrends: (sport: string, site: string, token: string) => void;
}

type Props = ReduxProps & DispatchProps;

const Trending = (props: Props) => {
  const { SetTrends, trends } = props;
  let { league } = useParams<PlayerCompareParams>();
  let queryParams = useQueryParams();
  const site = queryParams.get("site") || "";
  const token = queryParams.get("token") || "";

  const classes = useStyles();

  React.useEffect(() => {
    SetTrends(league, site, token);
  }, []);

  return (
    <div className={classes.root}>
      <Header />
      <div className={classes.cornerBackground}></div>
      <Grid container>
        <Grid item xs={12} className={classes.item}>
          <Heading />
        </Grid>
        {trends.status === APIConstants.SUCCEEDED &&
          trends.data?.slice(0, 5).map((trend, key) => {
            return (
              <Grid
                container
                item
                xs={12}
                justifyContent="center"
                className={`${classes.buttonWrapper}`}
                key={key + trend.displayText}
              >
                <Button
                  startIcon={<div className="rank">#{key + 1}</div>}
                  href={trend.url}
                  className={classes.button}
                  size="large"
                >
                  {trend.displayText}
                </Button>
              </Grid>
            );
          })}
        <Grid container item xs={12} justifyContent="center">
          <Link
            href="https://www.surveymonkey.com/r/PX3KKYF"
            className={classes.link}
          >
            Share your feedback!
          </Link>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  const { trends } = state.trending;
  return {
    trends,
  };
};

const mapDispatchToProps = {
  SetTrends: setTrends,
};

export default connect(mapStateToProps, mapDispatchToProps)(Trending);
